import Box from '@mui/material/Box';

import logoMark from 'assets/favicon/favicon-96x96.png';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return (
    <Box
      component="img"
      src={logoMark}
      alt="Liance"
      sx={{
        width: 34,
        height: 34,
        display: 'block',
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(17, 24, 39, 0.06)'
      }}
    />
  );
}
